import TNTControlBase from '../../util/TNTControlBase';

class ATMLoadProfileController extends TNTControlBase {
  /*@ngInject*/
  constructor($state) {
    super();
    this.acl = {}
    this.hasACL = {}
    this.id = 'atm_load_profile'
    this.$state = $state

  }
  $onInit() {
    super.$onInit()
    for (let key in this.acl['tnt_control_' + this.id]) {
      this.hasACL[this.acl['tnt_control_' + this.id][key]] = true;
    }
  }
}

export default ATMLoadProfileController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/atm_load_profile/atm_load_profile.controller.js